import { createStyles } from '@material-ui/core'

export const stylesMui = (theme) =>
  createStyles({
    headerButton: {
      textAlign: 'end'
    },
    rightButton: {
      margin: '1%'
    },
    tabsRoot: {
      marginBottom: '2%'
    },
    cardContainer: {
      margin: '1%',
      minHeight: '100vh'
    }
  })
